import React from 'react';
import { Space, Button, Popconfirm } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import type { ThinkingMode } from '../../../services/aiConfigService';

export const getColumns = (
  onEdit: (record: ThinkingMode) => void,
  onDelete: (id: string) => void
) => [
  { title: '思考方式ID', dataIndex: 'id', key: 'id', width: 150 },
  { title: '显示标签', dataIndex: 'label', key: 'label', width: 200 },
  { title: '分类', dataIndex: 'category', key: 'category', width: 120 },
  {
    title: '是否启用',
    dataIndex: 'isActive',
    key: 'isActive',
    width: 100,
    render: (val: boolean) => (val ? '是' : '否'),
  },
  {
    title: '操作',
    key: 'action',
    width: 150,
    fixed: 'right' as const,
    render: (_: any, record: ThinkingMode) => (
      <Space>
        <Button
          type="link"
          size="small"
          icon={<EditOutlined />}
          onClick={() => onEdit(record)}
          title="编辑"
        />
        <Popconfirm
          title="确定要删除该思考方式吗？"
          onConfirm={() => onDelete(record.id!)}
        >
          <Button type="link" danger size="small" icon={<DeleteOutlined />} title="删除" />
        </Popconfirm>
      </Space>
    ),
  },
];

export const tableConfig = {
  rowKey: 'id' as const,
  pagination: {
    pageSize: 20,
    showSizeChanger: true,
    showTotal: (total: number) => `共 ${total} 条`,
  },
};
